/* Phoenix Framers theme scripts — kept small and dependency-free. */
(function () {
  // Our Work category filters
  function initFilters(root) {
    var bar = root.querySelector('[data-pf-filter]');
    var grid = root.querySelector('[data-pf-grid]');
    if (!bar || !grid) return;
    var count = bar.querySelector('[data-pf-count]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tags]'));
    var wide = cards.map(function (c) { return c.classList.contains('is-wide'); });
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tag]');
      if (!btn) return;
      var tag = btn.getAttribute('data-tag');
      bar.querySelectorAll('[data-tag]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var shown = 0;
      cards.forEach(function (c, i) {
        var tags = (c.getAttribute('data-tags') || '').split(' ');
        var on = tag === 'all' || tags.indexOf(tag) !== -1;
        c.hidden = !on;
        if (on) shown++;
        c.classList.toggle('is-wide', tag === 'all' && wide[i]);
      });
      if (count) count.textContent = shown + (shown === 1 ? ' project' : ' projects');
    });
  }

  // Product option selects -> hidden variant select
  function initVariants(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form || form.closest('[data-pf-medal]')) return;
    var selects = form.querySelectorAll('[data-pf-option]');
    var master = form.querySelector('[data-pf-variants]');
    if (!selects.length || !master) return;
    var btn = form.querySelector('[type="submit"]');
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; }).join('||');
      var match = Array.prototype.find.call(master.options, function (o) { return o.getAttribute('data-options') === chosen; });
      if (match) {
        master.value = match.value;
        if (btn) { btn.disabled = match.disabled; btn.textContent = match.disabled ? 'Sold out' : 'Add to basket'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  // Close the mobile menu when a link inside it is followed
  function initDrawer(root) {
    var d = root.querySelector('#PfDrawer');
    if (!d) return;
    d.addEventListener('click', function (e) { if (e.target.closest('a')) d.removeAttribute('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.hasAttribute('open')) d.removeAttribute('open'); });
  }

  // Request a Quote: prefill notes when arriving from Design Your Frame (?spec=...)
  function initQuotePrefill(root) {
    var notes = root.querySelector('#q-notes');
    if (!notes || notes.value) return;
    var spec = new URLSearchParams(location.search).get('spec');
    if (!spec) return;
    notes.value = 'From Design Your Frame:\n' + spec.slice(0, 1200) + '\n\n';
  }

  function init(root) { initFilters(root); initVariants(root); initDrawer(root); initQuotePrefill(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
